const PUBLIC_API_PREFIX = "/api";

export const buildPublicApiUrl = (path) => {
    const route = path.startsWith("/") ? path : `/${path}`;
    return `${PUBLIC_API_PREFIX}${route}`;
};
